export default {
  heading: "建立密码",
  submitHeading:"启动教育城户口",
  intro: "请为您新登记的教城帐户 {id} 建立密码以启动帐户。",
  submitBtn: "确定",
  resetBtn: "重设",
  closeBtn: "关闭",
  completed:
    "成功启动教育城户口及更新密码。 ",
  recordNotFound: "很抱歉，您输入的网址有误。<br>请检查网址连结是否正确。如需协助，请电邮至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。",
  backToHome: "返回主页",
  hasActivated: "你已利用此连结启动教育城户口。这连结已失效。",
  expired: "这连结已超时失效。",
  userNotFound: "启动帐户错误。 ",
};
